<template>
  <div :class="['card-container', {'is-me': isMeCard }]">
    <div
      :style="`--text: '${rank}';`"
      :class="[
        'icon-rank',
        {
          'my': rank === 0,
          'first': rank === 1,
          'second': rank === 2,
          'third': rank === 3,
          'other': ![0, 1, 2, 3].includes(rank)
        }
      ]"
    />
    <div class="section-wrapper left">
      <div class="user-image-wrapper">
        <img
          :src="data.userImage"
          class="user-image"
        >
      </div>
      <div class="detail email">{{ data.email }}</div>
      <div class="reward-wrapper">
        <b-tooltip
          label="Lifetime VIP Membership"
          type="is-light"
        >
          <img
            v-if="[1].includes(rank)"
            src="/static/svg/icon-reward-vip.svg"
          >
        </b-tooltip>
        <b-tooltip
          label="MacBook Air M1"
          type="is-light"
        >
          <img
            v-if="[1].includes(rank)"
            src="/static/svg/icon-reward-macbook.svg"
          >
        </b-tooltip>
        <b-tooltip
          label="KULAP’s hoodie"
          type="is-light"
        >
          <img
            v-if="[1, 2, 3, 4, 5].includes(rank)"
            src="/static/svg/icon-reward-hoodie.svg"
          >
        </b-tooltip>
        <b-tooltip
          label="Surprise gift"
          type="is-light"
        >
          <img src="/static/svg/icon-reward-gift-trade.svg">
        </b-tooltip>
      </div>
    </div>
    <div class="section-wrapper right">
      <p class="detail text-title">Volume</p>
      <p class="detail volume">${{ data.totalVolume | numberWithComma(0) }}</p>
      <div class="detail token">
        <div class="img-wrapper">
          <img
            v-if="data.token.labelCode !== '-'"
            :src="`/static/token/normal/${data.token.labelCode.toLowerCase()}.svg`"
          >
        </div>
        <p class="detail token-name">{{ data.token.labelCode }}</p>
      </div>
      <b-tooltip
        label="Top token by volume"
        type="is-light"
        class="icon-info"
      >
        <img
          src="/static/svg/exchange-info.svg"
        >
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TraderCard',
  props: {
    data: {
      type: Object,
      default () {
        return {
          userId: '',
          userImage: require('../../../assets/svg/default-user-avatar.svg'),
          email: '-',
          totalVolume: 0,
          token: {
            labelCode: '-',
            fullName: '-'
          }
        }
      }
    },
    rank: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    isMeCard () {
      if (this.user && this.user.id === this.data.userId) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  width: 260px;
  max-height: 150px;
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 16px 16px 16px 8px;
  display: flex;
  justify-content: space-between;
  position: relative;
  &.is-me {
    box-shadow: 0 0 16px #3710dc;
  }
}
.section-wrapper {
  display: flex;
  flex-direction: column;
  &.left {
    max-width: 110px;
    .reward-wrapper {
      display: inline-flex;
      img {
        margin-right: 5px;
        width: 25px;
        height: 25px;
      }
    }
  }
  &.right {
    text-align: right;
  }
}
.img-wrapper {
    width: 25px;
    margin-right: 5px;
  img {
    width: 100%;
  }
}

.detail {
  &.email {
    word-wrap: break-word;
    font-size: 12px;
    font-weight: 600;
  }
  &.text-title {
    font-size: 13px;
    margin-bottom: 3px;
  }
  &.token-name {
    font-weight: 600;
    line-height: 25px;
  }
  &.volume {
    font-family: DINAlternate !important;;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 24px;
  }
  &.token {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
.icon-info {
  margin: 7px 0 0 70px;
}
.user-image-wrapper {
  width: 75px;
  height: 75px;
  margin: 0 0 10px 10px;
}
.user-image {
  background-color: #f0f0f0;
  box-shadow: 0 0 2px #929292;
  width: 100%;
  height: 100%;
  text-align: center;
  border-radius: 50%;
  object-fit: cover;
}
.icon-rank {
  position: absolute;
  top: -20px;
  left: -31px;
  width: 60px;
  height: 57px;
  &.my {
    // top: -15px;
    // left: -15px;
    // width: 100px;
    // height: 100px;
    // background-image: url('/static/svg/icon-gift-box.svg');
    // background-repeat: no-repeat;
    // background-size: auto;
  }
  &.first {
    background-image: url('/static/svg/icon-torphy-first.svg');
    background-repeat: no-repeat;
    background-size: auto;
  }
  &.second {
    background-image: url('/static/svg/icon-torphy-second.svg');
    background-repeat: no-repeat;
    background-size: auto;
  }
  &.third {
    background-image: url('/static/svg/icon-torphy-third.svg');
    background-repeat: no-repeat;
    background-size: auto;
  }
  &.other {
    &:before {
      content: var(--text);
      text-align: center;
      font-size: 17px;
      font-weight: 700;
      line-height: 40px;
      left: 0px;
      right: 0;
      position: absolute;
    }
    width: 40px;
    height: 40px;
    top: -20px;
    left: -20px;
    color: white;
    background: #3F8EF9;
    border-radius: 50%;
    // position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/TopTrader/components/TraderCard.vue